import { Link } from "react-router-dom";
import { latestVideos } from "@/mocks/videos";

export default function LatestUpdates() {
  return (
    <section className="w-full bg-background-100 py-12 md:py-16">
      <div className="mx-auto w-full max-w-[1440px] px-4 md:px-8">
        <div className="mb-6 flex items-end justify-between gap-4">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-6 w-1.5 rounded-full bg-accent-500"></span>
              <h2 className="text-xl font-black text-foreground-950 md:text-2xl">最新更新</h2>
            </div>
            <p className="mt-2 text-sm text-foreground-500">刚刚上线与最新集数，抢先一步追更</p>
          </div>
          <span className="hidden items-center gap-1 text-sm text-foreground-500 sm:flex">
            <i className="ri-drag-move-2-line"></i>
            左右滑动查看
          </span>
        </div>

        <div className="no-scrollbar flex gap-4 overflow-x-auto pb-2">
          {latestVideos.map((video) => (
            <Link
              key={video.id}
              to={`/detail/${video.id}`}
              className="group w-[150px] shrink-0 cursor-pointer md:w-[170px]"
            >
              <div className="relative aspect-[2/3] w-full overflow-hidden rounded-lg bg-background-200">
                <img
                  src={video.cover}
                  alt={`${video.title} 最新更新`}
                  title={`${video.title} 最新集`}
                  className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 flex items-center justify-center bg-foreground-950/0 transition-colors group-hover:bg-foreground-950/40">
                  <span className="flex h-10 w-10 scale-90 items-center justify-center rounded-full bg-primary-500/90 text-background-50 opacity-0 transition-all group-hover:scale-100 group-hover:opacity-100">
                    <i className="ri-play-fill text-xl"></i>
                  </span>
                </div>
                <span className="absolute bottom-2 right-2 rounded bg-foreground-950/70 px-1.5 py-0.5 text-[10px] font-medium text-background-50 backdrop-blur-sm">
                  {video.duration}
                </span>
              </div>
              <div className="pt-2">
                <h3 className="line-clamp-1 text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
                  {video.title}
                </h3>
                <p className="mt-1 flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-calendar-line"></i>
                  {video.updateDate}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}